export default "__VITE_ASSET__sDUEnysE__"